document.addEventListener("turbo:load", function () {
  const navbarElm = document.querySelector(".ws-navbar.sticky-top");
  if (!navbarElm) return;

  window.addEventListener('scroll', scrollFunction);

  function scrollFunction() {
    if (
      document.body.scrollTop > 0 ||
      document.documentElement.scrollTop > 0
    ) {
      navbarElm.classList.add("is-sticky");
    } else {
      navbarElm.classList.remove("is-sticky");
    }
  }
});

// Smooth dropdown hover functionality
// Initialize immediately AND on turbo:load for navigation changes
let hoverTimeouts = new Map(); // Use Map to track timeouts per dropdown
let dropdownListeners = [];
let resizeTimeout;

function initializeDropdownHover() {

  // Helper function to check if device supports hover (not touch-only)
  function supportsHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  // Helper function to check if we're on mobile/tablet
  function isMobileDevice() {
    // Check screen width (Bootstrap lg breakpoint)
    if (window.innerWidth <= 992) return true;

    // Check for touch-only devices
    if (!supportsHover()) return true;

    // Check user agent for mobile indicators (fallback)
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = ['mobile', 'tablet', 'android', 'iphone', 'ipad', 'ipod'];
    const isMobileUA = mobileKeywords.some(keyword => userAgent.includes(keyword));

    return isMobileUA;
  }

  // Simple function to show dropdown
  function showDropdown(toggle, menu) {
    // Close all other dropdowns first
    document.querySelectorAll(".ws-navbar .dropdown-menu.show").forEach(function(otherMenu) {
      if (otherMenu !== menu) {
        otherMenu.classList.remove("show");
        const otherToggle = otherMenu.previousElementSibling;
        if (otherToggle) {
          otherToggle.classList.remove("show");
          otherToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });

    // Show current dropdown
    toggle.classList.add("show");
    toggle.setAttribute('aria-expanded', 'true');
    menu.classList.add("show");
  }

  // Simple function to hide dropdown
  function hideDropdown(toggle, menu) {
    toggle.classList.remove("show");
    toggle.setAttribute('aria-expanded', 'false');
    menu.classList.remove("show");
  }

  function initDropdownHover() {
    // Clean up existing listeners
    cleanupDropdownListeners();

    // Only enable hover on desktop devices - enhanced mobile detection
    if (!isMobileDevice()) {
      // Initialize immediately - no setTimeout needed
      document.querySelectorAll(".ws-navbar .nav-item.dropdown").forEach(function (navItem) {
        const dropdown = navItem.querySelector(".dropdown-menu");
        const dropdownToggle = navItem.querySelector(".dropdown-toggle");

        if (!dropdown || !dropdownToggle) return;

        // Check if mouse is already hovering over this element on page load
        if (navItem.matches(':hover')) {
          showDropdown(dropdownToggle, dropdown);
        }

          // Create unique key for this dropdown
          const dropdownKey = Math.random().toString(36).substr(2, 9);

          const mouseEnterHandler = function (e) {
            // Double-check we're not on mobile before handling hover
            if (isMobileDevice()) return;

            // Clear any pending hide timeout for this dropdown
            if (hoverTimeouts.has(dropdownKey)) {
              clearTimeout(hoverTimeouts.get(dropdownKey));
              hoverTimeouts.delete(dropdownKey);
            }

            // Show dropdown immediately
            showDropdown(dropdownToggle, dropdown);
          };

          const mouseLeaveHandler = function (e) {
            // Double-check we're not on mobile before handling hover
            if (isMobileDevice()) return;

            // Set timeout to hide dropdown
            const timeoutId = setTimeout(function() {
              // Double-check that we're not hovering over the dropdown itself
              if (!dropdown.matches(':hover') && !navItem.matches(':hover')) {
                hideDropdown(dropdownToggle, dropdown);
              }
              hoverTimeouts.delete(dropdownKey);
            }, 150);

            hoverTimeouts.set(dropdownKey, timeoutId);
          };

          const dropdownEnterHandler = function (e) {
            // Double-check we're not on mobile before handling hover
            if (isMobileDevice()) return;

            // Clear any pending hide timeout when entering dropdown
            if (hoverTimeouts.has(dropdownKey)) {
              clearTimeout(hoverTimeouts.get(dropdownKey));
              hoverTimeouts.delete(dropdownKey);
            }
          };

          const dropdownLeaveHandler = function (e) {
            // Double-check we're not on mobile before handling hover
            if (isMobileDevice()) return;

            // Only hide if we're not still hovering over the nav item
            if (!navItem.matches(':hover')) {
              const timeoutId = setTimeout(function() {
                hideDropdown(dropdownToggle, dropdown);
                hoverTimeouts.delete(dropdownKey);
              }, 150);

              hoverTimeouts.set(dropdownKey, timeoutId);
            }
          };

          // Prevent hover events when dropdown is opened via click
          const clickHandler = function(e) {
            // Clear any hover timeouts
            if (hoverTimeouts.has(dropdownKey)) {
              clearTimeout(hoverTimeouts.get(dropdownKey));
              hoverTimeouts.delete(dropdownKey);
            }
          };

          // Add event listeners
          navItem.addEventListener("mouseenter", mouseEnterHandler);
          navItem.addEventListener("mouseleave", mouseLeaveHandler);
          dropdown.addEventListener("mouseenter", dropdownEnterHandler);
          dropdown.addEventListener("mouseleave", dropdownLeaveHandler);
          dropdownToggle.addEventListener("click", clickHandler);

          // Store listeners for cleanup
          dropdownListeners.push({
            element: navItem,
            event: "mouseenter",
            handler: mouseEnterHandler
          });
          dropdownListeners.push({
            element: navItem,
            event: "mouseleave",
            handler: mouseLeaveHandler
          });
          dropdownListeners.push({
            element: dropdown,
            event: "mouseenter",
            handler: dropdownEnterHandler
          });
          dropdownListeners.push({
            element: dropdown,
            event: "mouseleave",
            handler: dropdownLeaveHandler
          });
          dropdownListeners.push({
            element: dropdownToggle,
            event: "click",
            handler: clickHandler
          });
        });
    }
  }

  function cleanupDropdownListeners() {
    // Clear all timeouts
    hoverTimeouts.forEach(function(timeoutId) {
      clearTimeout(timeoutId);
    });
    hoverTimeouts.clear();

    // Remove all event listeners
    dropdownListeners.forEach(function(listener) {
      listener.element.removeEventListener(listener.event, listener.handler);
    });
    dropdownListeners = [];

    // Close all dropdowns
    document.querySelectorAll(".ws-navbar .dropdown-menu.show").forEach(function(dropdown) {
      dropdown.classList.remove("show");
      const toggle = dropdown.previousElementSibling;
      if (toggle) {
        toggle.classList.remove("show");
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Throttled resize handler
  function throttledResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      initDropdownHover();
    }, 100);
  }

  // Throttled resize handler
  function throttledResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      initDropdownHover();
    }, 100);
  }

  // Initialize
  initDropdownHover();

  // Re-initialize on window resize (throttled)
  window.addEventListener('resize', throttledResize);

  // Handle hover state changes (useful for hybrid devices)
  window.matchMedia('(hover: hover) and (pointer: fine)').addEventListener('change', function() {
    initDropdownHover();
  });

  // Additional safeguard: Clean up on orientation change (mobile devices)
  window.addEventListener('orientationchange', function() {
    setTimeout(function() {
      if (isMobileDevice()) {
        cleanupDropdownListeners();
      }
    }, 100);
  });
}

// Initialize immediately on script load
initializeDropdownHover();

// Re-initialize on turbo:load for navigation changes
document.addEventListener("turbo:load", function () {
  initializeDropdownHover();
});
